export const mixPanelConfig_prod = {
  mixpanel_token: 'a7dfd719149340e788c5ccdefb6ef89d',
};
